import { getPageType, getABTestFeatures, getElementText, safeDocument, safeWindow, safePerformance, } from './utils';
export const createEventSender = (sendData, pageLoadTime, config, shouldSend) => {
    const state = {
        pageStartTime: safePerformance.now(),
        activeStartTime: safeDocument.hidden ? null : safePerformance.now(),
        totalActiveTime: 0,
        isPageVisible: !safeDocument.hidden,
    };
    function resetTime() {
        state.pageStartTime = safePerformance.now();
        state.activeStartTime = safeDocument.hidden
            ? null
            : state.pageStartTime;
        state.totalActiveTime = 0;
        state.isPageVisible = !safeDocument.hidden;
    }
    function handleVisibilityChange() {
        const now = safePerformance.now();
        state.isPageVisible = !safeDocument.hidden;
        if (safeDocument.hidden) {
            if (state.activeStartTime !== null) {
                state.totalActiveTime += now - state.activeStartTime;
                state.activeStartTime = null;
            }
        }
        else {
            state.activeStartTime = now;
        }
    }
    function handlePageExit() {
        if (!shouldSend())
            return;
        const now = safePerformance.now();
        const timeOnPage = now - state.pageStartTime;
        if (state.isPageVisible && state.activeStartTime !== null) {
            state.totalActiveTime += now - state.activeStartTime;
        }
        void sendData('exit', {
            timeOnPage: Math.round(timeOnPage),
            activeTime: Math.round(state.totalActiveTime),
        });
    }
    function sendClick(event) {
        const target = event.target;
        if (!target)
            return;
        const mouseEvent = event;
        const xPos = typeof mouseEvent.pageX === 'number' ? mouseEvent.pageX : 0;
        const yPos = typeof mouseEvent.pageY === 'number' ? mouseEvent.pageY : 0;
        const clickData = {
            elementType: target.tagName.toLowerCase(),
            elementId: target.id || undefined,
            elementText: getElementText(target),
            elementHref: target.href || undefined,
            xPos,
            yPos,
        };
        void sendData('click', clickData);
    }
    function sendFormSubmit(event) {
        const form = event.target;
        if (!form)
            return;
        void sendData('form_submit');
    }
    const hasDocumentListeners = safeDocument.addEventListener('visibilitychange', handleVisibilityChange);
    const hasWindowListeners = safeWindow.addEventListener('beforeunload', handlePageExit) &&
        safeWindow.addEventListener('pagehide', handlePageExit);
    resetTime();
    return {
        sendPageView: () => {
            if (!config.pageView)
                return;
            if (state.pageStartTime && state.totalActiveTime > 0) {
                handlePageExit();
            }
            resetTime();
            const location = safeWindow.location;
            const pageViewData = {
                pageTitle: safeDocument.title,
                pageType: getPageType(location.pathname),
                path: location.pathname,
                referrer: safeDocument.referrer,
            };
            void sendData('page_view', pageViewData, {
                features: getABTestFeatures(),
            });
        },
        initClickSending: () => {
            if (!config.click)
                return;
            safeDocument.addEventListener('click', sendClick);
        },
        initFormSending: () => {
            if (!config.form)
                return;
            safeDocument.addEventListener('submit', sendFormSubmit);
        },
        sendModalView: (modalId, modalType) => {
            if (!config.modal)
                return;
            const modalData = {
                modalId,
                modalType,
                timeToShow: Math.round(safePerformance.now() - pageLoadTime),
            };
            void sendData('modal_view', modalData);
        },
        destroy: () => {
            if (hasDocumentListeners) {
                safeDocument.removeEventListener('visibilitychange', handleVisibilityChange);
            }
            if (hasWindowListeners) {
                safeWindow.removeEventListener('beforeunload', handlePageExit);
                safeWindow.removeEventListener('pagehide', handlePageExit);
            }
            if (config.click) {
                safeDocument.removeEventListener('click', sendClick);
            }
            if (config.form) {
                safeDocument.removeEventListener('submit', sendFormSubmit);
            }
        },
    };
};
